import { CardMedia } from '@sbercloud/uikit-product-site-cards';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useLayoutType } from 'src/hooks/useLayoutType';
import { BlogsProps } from 'src/types/backendContent';
import { formatDate } from 'src/utils/formatDate';

export function NewsSlide(blog: BlogsProps) {
  const layoutType = useLayoutType();
  const { clickAnalytics } = useAnalytics();

  return (
    <CardMedia
      size="s"
      title={blog.title}
      date={formatDate(blog.releaseDate)}
      img={blog.cover}
      href={`/blog/${blog.slug}`}
      titleTag="span"
      tag={{
        label: blog.categoryTitle,
      }}
      layoutType={layoutType}
      onClick={() => {
        clickAnalytics({
          action: `/blog/${blog.slug}`,
          clickZone: 'body',
          clickElement: 'cardclick',
          clickContent: blog.title,
          uniqueId: `blog-carousel-card-${blog.title}`,
          transitionType: 'inside-link',
          clickZoneCategory: 'site-body',
          transitionUrl: `/blog/${blog.slug}`,
          transitionTypeMetrics: 'internal',
        });
      }}
    />
  );
}
